var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "cms-divider-block", style: _vm.containerStyle },
    [_c("hr", { staticClass: "cms-divider-block__line", style: _vm.hrStyle })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }